<template>
  <div class="w-100">
    <div
      v-if="isMultiline"
      class="MultilineWrapper"
    >
      <div class="row">
        <div
          v-if="isLanguageEnabled('de-CH')"
          :class="languageClass"
          class="pl-0"
        >
          <div v-if="readonly">
            <v-label> Deutsch </v-label>
            <div>
              {{ text["de-CH"] }}
            </div>
          </div>
          <div v-else>
            <v-textarea
              ref="deTextArea"
              v-model="text['de-CH']"
              auto-grow
              label="Deutsch"
              rows="1"
              @input="textUpdated('de-CH')"
            >
              <template slot="append">
                <i
                  v-b-tooltip.hover
                  class="fas fa-language appendApplyIcon"
                  placement="bottom"
                  title="Wert für alle Sprachen übernehmen"
                  type="button"
                  @click="setAllLanguageTexts(text['de-CH'])"
                />
              </template>
            </v-textarea>
          </div>
        </div>

        <div
          v-if="isLanguageEnabled('fr-CH')"
          :class="languageClass"
          class="pl-0"
        >
          <div v-if="readonly">
            <v-label> Französisch </v-label>
            <div>
              {{ text["fr-CH"] }}
            </div>
          </div>
          <div v-else>
            <v-textarea
              v-model="text['fr-CH']"
              auto-grow
              label="Französisch"
              rows="1"
              @input="textUpdated('fr-CH')"
            >
              <template slot="append">
                <i
                  v-b-tooltip.hover
                  class="fas fa-language appendApplyIcon"
                  placement="bottom"
                  title="Wert für alle Sprachen übernehmen"
                  type="button"
                  @click="setAllLanguageTexts(text['fr-CH'])"
                />
              </template>
            </v-textarea>
          </div>
        </div>

        <div
          v-if="isLanguageEnabled('it-CH')"
          :class="languageClass"
          class="pl-0"
        >
          <div v-if="readonly">
            <v-label> Italienisch </v-label>
            <div>
              {{ text["it-CH"] }}
            </div>
          </div>
          <div v-else>
            <v-textarea
              v-model="text['it-CH']"
              auto-grow
              label="Italienisch"
              rows="1"
              @input="textUpdated('it-CH')"
            >
              <template slot="append">
                <i
                  v-b-tooltip.hover
                  class="fas fa-language appendApplyIcon"
                  placement="bottom"
                  title="Wert für alle Sprachen übernehmen"
                  type="button"
                  @click="setAllLanguageTexts(text['it-CH'])"
                />
              </template>
            </v-textarea>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div
        v-if="readonly && isLanguageEnabled('de-CH')"
        class="mb-1"
      >
        <v-label> Deutsch </v-label>
        <div>
          {{ text["de-CH"] }}
        </div>
      </div>
      <div v-else>
        <v-text-field
          v-if="isLanguageEnabled('de-CH')"
          v-model="text['de-CH']"
          label="Deutsch"
          @input="textUpdated('de-CH')"
        >
          <template slot="append">
            <i
              v-b-tooltip.hover
              class="fas fa-language appendApplyIcon"
              placement="bottom"
              title="Wert für alle Sprachen übernehmen"
              type="button"
              @click="setAllLanguageTexts(text['de-CH'])"
            />
          </template>
        </v-text-field>
      </div>

      <div
        v-if="readonly && isLanguageEnabled('fr-CH')"
        class="mb-1"
      >
        <v-label> Französisch </v-label>
        <div>
          {{ text["fr-CH"] }}
        </div>
      </div>
      <div v-else>
        <v-text-field
          v-if="isLanguageEnabled('fr-CH')"
          v-model="text['fr-CH']"
          label="Französisch"
          @input="textUpdated('fr-CH')"
        >
          <template slot="append">
            <i
              v-b-tooltip.hover
              class="fas fa-language appendApplyIcon"
              placement="bottom"
              title="Wert für alle Sprachen übernehmen"
              type="button"
              @click="setAllLanguageTexts(text['fr-CH'])"
            />
          </template>
        </v-text-field>
      </div>

      <div v-if="readonly && isLanguageEnabled('it-CH')">
        <v-label> Italienisch </v-label>
        <div>
          {{ text["it-CH"] }}
        </div>
      </div>
      <div v-else>
        <v-text-field
          v-if="isLanguageEnabled('it-CH')"
          v-model="text['it-CH']"
          label="Italienisch"
          @input="textUpdated('it-CH')"
        >
          <template slot="append">
            <i
              v-b-tooltip.hover
              class="fas fa-language appendApplyIcon"
              placement="bottom"
              title="Wert für alle Sprachen übernehmen"
              type="button"
              @click="setAllLanguageTexts(text['it-CH'])"
            />
          </template>
        </v-text-field>
      </div>
    </div>
  </div>
</template>

<script>
import { MultiLangMixin } from "@/mixins/MultilanguageContentsMixin";

export default {
  mixins: [MultiLangMixin],
  props: {
    value: {
      type: Array,
      required: true,
    },
    contentPropertyName: {
      type: String,
      required: true,
    },
    languages: {
      type: Array,
      default() {
        return [
          { language: "de-CH" },
          { language: "fr-CH" },
          { language: "it-CH" },
        ];
      },
    },
    isMultiline: {
      type: Boolean,
      default: false,
    },
    showAllLanguages: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    hideLanguages: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valueCopy: null,
      text: {
        "de-CH": "",
        "fr-CH": "",
        "it-CH": "",
      },
    };
  },
  computed: {
    computedLanguages() {
      return [...this.languages];
    },
    translatedLanguages() {
      const translated =
        this.$store.state.mindestLohnKonfiguration.BasicContractInformation
          .translatedLanguages;
      return translated || this.languages;
    },
    languageClass() {
      const length = this.translatedLanguages.length;
      return {
        "col-4": length == 3,
        "col-6": length == 2,
        "col-12": length == 1,
      };
    },
  },
  watch: {
    value(newValue) {
      this.valueCopy = JSON.parse(JSON.stringify(newValue));
    },
  },
  created() {
    this.valueCopy = JSON.parse(JSON.stringify(this.value));
    this.initializeTexts();
  },
  methods: {
    initializeTexts() {
      this.text["de-CH"] = this.getContentForLanguage(
        this.valueCopy,
        "de-CH",
        this.contentPropertyName,
        "",
      );
      this.text["fr-CH"] = this.getContentForLanguage(
        this.valueCopy,
        "fr-CH",
        this.contentPropertyName,
        "",
      );
      this.text["it-CH"] = this.getContentForLanguage(
        this.valueCopy,
        "it-CH",
        this.contentPropertyName,
        "",
      );
    },
    setAllLanguageTexts(newText) {
      this.translatedLanguages.forEach((language) => {
        this.text[language.language] = newText;
        this.textUpdated(language.language);
      });
    },
    textUpdated(language) {
      this.setContentForLanguage(
        this.valueCopy,
        language,
        this.text[language],
        this.contentPropertyName,
      );
      this.$emit("input", JSON.parse(JSON.stringify(this.valueCopy)));
    },
    isLanguageEnabled(language) {
      if (this.showAllLanguages) {
        return true;
      }
      return this.translatedLanguages.some(
        (enabledLanguage) => enabledLanguage.language === language,
      );
    },
  },
};
</script>
<style scoped>
.MultilineWrapper .row {
  margin-left: 0px;
}

.v-label {
  font-size: 12px;
}

.appendApplyIcon {
  display: none;
  font-size: 20px;
}

.v-input--is-focused .appendApplyIcon {
  display: initial;
}
</style>
